<script setup lang="ts">
import { provide } from "vue";

export interface IconListProps {
  size?: "medium" | "small";
}

const { size = "medium" } = defineProps<IconListProps>();

provide("iconListContext", { size });
</script>

<template>
  <div>
    <ul class="flex flex-col gap-y-3">
      <slot></slot>
    </ul>
  </div>
</template>
